<script>
import { useSetupStore } from '@/stores';
import { checkRestrictions } from '@/helpers'

export default {
    name: 'Markenting',
    beforeRouteEnter(to, from, next) {
        const setupStore = useSetupStore();
        if (checkRestrictions(['statistics'])) {
            next({ name: 'statistics' })
        } else if (setupStore.enabledExtensions.includes('marketing') && checkRestrictions(['ex:marketing', 'ex:marketing:campaigns'])) {
            next({ name: 'campaigns' });
        } else if (setupStore.enabledExtensions.includes('newsletter') && checkRestrictions(['ex:newsletter'])) {
            next({ name: 'newsletters' });
        } else if (setupStore.enabledExtensions.includes('shop') && checkRestrictions(['ex:shop', 'ex:shop:coupons'])) {
            next({ name: 'coupons' });
        }
        // if (this.enabledExtensions.includes('newsletter')) {
    },
}
</script>
